"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const featureToggle_1 = require("modules/featureToggle");
class AppWrapperUtil {
}
AppWrapperUtil.initFeatures = (productId) => {
    const featureToggles = [
        featureToggle_1.FeatureToggles.AddClassModules,
        featureToggle_1.FeatureToggles.ContentStructureAI,
        featureToggle_1.FeatureToggles.LegacyRedirectAlert,
        featureToggle_1.FeatureToggles.CtaCommunities,
        featureToggle_1.FeatureToggles.CertificateQrCode,
        featureToggle_1.FeatureToggles.SurveyThirdyProducts,
        featureToggle_1.FeatureToggles.ActivateFreeSignup,
        featureToggle_1.FeatureToggles.PromoteProductModal,
        featureToggle_1.FeatureToggles.CreateModuleConcept,
        featureToggle_1.FeatureToggles.EnableNewClubTemplateExperiment,
        featureToggle_1.FeatureToggles.EnableNewClubMigrationCTA
    ];
    featureToggles.forEach((featureToggleName) => {
        featureToggle_1.FeatureToggleService.addRemoteFeature(featureToggleName, productId);
    });
};
AppWrapperUtil.initFeaturesByUser = (userId) => {
    const featureToggles = [
        featureToggle_1.FeatureToggles.EnableMentorshipExperiment,
        featureToggle_1.FeatureToggles.CreateContentConcept,
        featureToggle_1.FeatureToggles.BulkActionMenu,
        featureToggle_1.FeatureToggles.ContentListConcept
    ];
    featureToggles.forEach((featureToggleName) => {
        featureToggle_1.FeatureToggleService.addRemoteFeature(featureToggleName, userId);
    });
};
exports.default = AppWrapperUtil;
